/* eslint-disable react/prop-types */
import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Input } from 'antd'
import { WrapperFormItem, WrapperLabel } from '../FormInput'

const FormInputPassword = ({ label, name, rules, defaultValue = '', wrapperProps, placeholder, isAutoComplete, ...rest }) => {
  const { control } = useFormContext()
  const { field: { onChange, value }, fieldState: { error } } = useController({ name, control, rules, defaultValue })
  return (
    <WrapperFormItem
      {...wrapperProps}
      label={label && <WrapperLabel>{label}</WrapperLabel>}
      validateStatus={(error) ? 'error' : ''}
      help={error?.message}
      {...rest}
    >
      <Input.Password name={name} autoComplete={isAutoComplete} placeholder={placeholder} onChange={onChange} value={value} {...rest} />
    </WrapperFormItem>
  )
}

export default FormInputPassword
